module.exports = __webpack_public_path__ + "img/button_current_02.1b58cfa2.png";